import React from 'react';
import Match from './Match';
import MatchSection from './MatchSection';
import MatchSectionBottom from './MatchSectionBottom';
import Winner from './Winner';
import {MatchInterface} from './matchInterface';

interface Props {
    winnerMatches: {
        [round: number]: MatchInterface[] | undefined
    }
    loserMatches: {
        [round: number]: MatchInterface[] | undefined
    }
}

const STAGE_ONE = 1;
const STAGE_TWO = 2;
const STAGE_THREE = 3;
const STAGE_FOUR = 4;
const STAGE_FIVE = 5;
const STAGE_SIX = 6;
const STEP = 2;

const Grid: React.FC<Props> = ({winnerMatches = {}, loserMatches = {}}) => {
    const renderMatchSection = (stage: number): React.ReactNode => {
        const grupedCurrentStage = [];
        const numberOfMatch = 4;
        const amountMatchSection = Math.floor(numberOfMatch / stage);
        const currentStage = winnerMatches[stage] || [];

        if (currentStage && currentStage.length > 0) {
            for (let i = 0; i < currentStage.length; i += STEP) {
                grupedCurrentStage.push(currentStage.slice(i, i + STEP));
            }
        }

        if (amountMatchSection - grupedCurrentStage.length > 0) {
            grupedCurrentStage.push(...Array(amountMatchSection - grupedCurrentStage.length).fill([]));
        }

        return grupedCurrentStage.map((match, index) => <MatchSection matches={match} key={`match-section-${stage}-${index}`} />);
    };

    const renderMatchSectionBottom = (stage: number, rounds: number[]) => {
        const numberOfMatch = 2;
        const amountMatchSection = Math.floor(numberOfMatch / stage);
        const grupedSection = [];
        const matchesInRound1 = loserMatches && loserMatches[rounds[0]] || [];
        const matchesInRound2 = loserMatches && loserMatches[rounds[1]] || [];

        for (let i = 0; i < amountMatchSection * STEP; i += STEP) {
            const line1 = [matchesInRound1[i], matchesInRound2[i]];
            const line2 = [matchesInRound1[i + 1], matchesInRound2[i + 1]];
            grupedSection.push(<MatchSectionBottom line1={line1} line2={line2} key={`match-section-bottom-${stage}-${i}`}/>);
        }

        return grupedSection;
    };

    const getDataForMixedSection = (): MatchInterface[] => {
        const winnerMatch = winnerMatches && winnerMatches[STAGE_FOUR] || [];
        const loserMatch = loserMatches && loserMatches[STAGE_SIX] || [];

        return [...winnerMatch, ...loserMatch];
    };

    const getDefiniteMatch = (round: number, isWinner = true): MatchInterface | undefined => (isWinner ? winnerMatches : loserMatches)?.[round]?.[0];

    return <div className="tournament-grid">
        <div className="tournament-grid-inner">
            <div className="tournament-grid-section tournament-grid-section-1">
                {renderMatchSection(STAGE_ONE)}
                <div className="tournament-grid-section-bottom">
                    {renderMatchSectionBottom(STAGE_ONE, [STAGE_ONE, STAGE_TWO])}
                </div>
            </div>
            <div className="tournament-grid-section tournament-grid-section-2">
                {renderMatchSection(STAGE_TWO)}
                {renderMatchSectionBottom(STAGE_TWO, [STAGE_THREE, STAGE_FOUR])}
            </div>
            <div className="tournament-grid-section tournament-grid-section-3">
                {renderMatchSection(STAGE_THREE)}
                <div className="tournament-grid-section-bottom">
                    <Match match={getDefiniteMatch(STAGE_FIVE, false)} />
                </div>
            </div>
            <div className="tournament-grid-section tournament-grid-section-4">
                <MatchSection matches={getDataForMixedSection()} />
            </div>
            <div className="tournament-grid-section tournament-grid-section-5">
                <Match match={getDefiniteMatch(STAGE_FIVE, true)} />
            </div>
            <div className="tournament-grid-section tournament-grid-section-6">
                <Winner match={getDefiniteMatch(STAGE_SIX, true)} />
            </div>
        </div>
    </div>;
};

export default Grid;
